import moment from 'moment';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {connect} from 'react-redux';
import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import * as AppConst from '../../constants/App';
import ExternalCalendars from './ExternalCalendars';
import ExportCalendarModal from './ExportCalendarModal';
import ImportCalendarModal from './ImportCalendarModal';
import {loadCalendar, updateDays} from '../../actions/CreatingObjectPage';
import Calendar from './Calendar';

import iconClosePNG from '../../static/img/new/icon-close.png';
import {CURRENCY} from "../../constants/Property";

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

const defaultProps = {
    updateDays: (objectId, updateDaysCommand) => {
    },
    loadCalendar: (objectId, calendarSearchCommand) => {
    }
};

class CalendarTab extends Component {
    state = {
        price: '',
        minNights: '',
        isPriceDisabled: false,
        isMinNightsDisabled: false,
        showExportCalendarModal: false,
        showImportCalendarModal: false,

        currentYear: undefined,
        currentMonth: undefined,
        selected: []
    };


    refreshCalendar() {
        let {currentMonth, currentYear, lastStartDate, lastEndDate} = this.state;
        this.handleMonthChange(currentMonth, currentYear, lastStartDate, lastEndDate);
    }

    handleMonthChange(month, year, startDate, endDate) {
        this.setState({
            currentYear: year,
            currentMonth: month,

            lastStartDate: startDate,
            lastEndDate: endDate
        });

        const calendarSearchCommand = {};
        calendarSearchCommand.startDate = startDate.format(AppConst.DATE_FORMAT);
        calendarSearchCommand.endDate = endDate.format(AppConst.DATE_FORMAT);

        let propertyId = this.props.objectId;
        if (propertyId === undefined) {
            propertyId = this.props.propertyIdUrl;
        }

        let getCancelSource = (source) => {
            this.setState({cancellationLoadCalendarFunction: source});
        };

        if (this.state.cancellationLoadCalendarFunction !== undefined) {
            this.state.cancellationLoadCalendarFunction.cancel();
            this.setState({cancellationLoadCalendarFunction: undefined});
        }

        this.props.loadCalendar(propertyId, calendarSearchCommand, getCancelSource);
    }

    handleDayClick(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum, externalCalendarName) {
        if (date.isBefore(moment().subtract(1, 'days'))) {
            return;
        }

        if (bookingId != null) {
            return;
        }

        if (externalCalendarName != null) {
            return;
        }

        const day = {
            date: date.format(AppConst.CALENDAR_DATE_FORMAT),
            blocked: !blocked
        };

        this.props.updateDays(this.props.objectId, {days: [day]});
    }

    handleSelectedChange(selected) {
        this.setState({selected: selected});
    }

    updateDays(days) {
        const updateDaysCommand = {
            days: days
        };
        this.props.updateDays(this.props.objectId, updateDaysCommand);
    }

    handleDateChange(date, type) {
        if (
            !date.isBefore(moment().subtract(1, 'days')) &&
            (type !== AppConst.TYPE.endDate || !date.isBefore(this.state.startDate))
        ) {
            const newState = {};
            newState[type] = date;

            this.setState(newState);
        }
    }

    handleDateClear(event) {
        event.preventDefault();

        const newState = {};
        newState[event.target.name] = undefined;

        this.setState(newState);
    }

    handleBlockedChange = value => {
        this.setState(prevState => ({
            isBlocked: prevState.isBlocked === undefined || prevState.isBlocked !== value ? value : undefined
        }));
    };

    handlePriceDisabledChange = () => {
        this.setState(prevState => ({
            isPriceDisabled: !prevState.isPriceDisabled
        }));
    };

    handleMinNightsDisabledChange = () => {
        this.setState(prevState => ({
            isMinNightsDisabled: !prevState.isMinNightsDisabled
        }));
    };

    handleInputChange(event) {
        const newState = {};
        newState[event.target.name] = event.target.value;

        this.setState(newState);
    }

    handleSetParametersClick(event) {
        event.preventDefault();

        const {price, minNights, isBlocked, isPriceDisabled, isMinNightsDisabled, selected} = this.state;
        let isValid = true;

        if (!this.state.isPriceDisabled && this.state.price.length === 0) {
            isValid = false;
        }

        if (!this.state.isMinNightsDisabled && this.state.minNights.length === 0) {
            isValid = false;
        }

        if (selected.length === 0) {
            if (this.state.startDate === undefined) {
                isValid = false;
            } else if (this.state.endDate === undefined) {
                isValid = false;
            } else if (this.state.endDate.isBefore(this.state.startDate)) {
                isValid = false;
            }
        }

        if (isValid && selected.length === 0) {
            let days = [];
            let dayMoment = moment(this.state.startDate.format(AppConst.CALENDAR_DATE_FORMAT), AppConst.CALENDAR_DATE_FORMAT);

            do {
                let day = {
                    blocked: isBlocked,
                    price: isPriceDisabled ? undefined : price,
                    date: dayMoment.format(AppConst.CALENDAR_DATE_FORMAT),
                    minNights: isMinNightsDisabled ? undefined : minNights
                };
                days.push(day);
                dayMoment.add(1, 'days');
            } while (!dayMoment.isAfter(this.state.endDate));

            this.updateDays(days);
        }

        if (isValid && selected.length !== 0) {
            let days = [];

            selected.forEach(d => {
                days.push({
                    blocked: isBlocked,
                    price: isPriceDisabled ? undefined : price,
                    date: d,
                    minNights: isMinNightsDisabled ? undefined : minNights
                })
            });

            this.updateDays(days);
        }
    }

    onDeleteExternalCalendar() {
        this.refreshCalendar();
    }

    render() {
        const {isBlocked, isPriceDisabled, isMinNightsDisabled} = this.state;
        const {i18n, isShowCalendarLoading, isActive, code} = this.props;
        let currentMonthToOpen = undefined;


        let {startDate, endDate} = this.state;
        if (this.state.currentYear !== undefined && this.state.currentMonth !== undefined) {
            currentMonthToOpen = moment({y: this.state.currentYear, M: this.state.currentMonth - 1, d: 1});
        }

        let {currentDays, currentDaysCurrency} = this.props;

        let currentDaysCurrencyMark = '';
        if (currentDaysCurrency !== undefined) {
            currentDaysCurrencyMark = CURRENCY[currentDaysCurrency].mark;
        }

        return (
            <div
                className={isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'}
            >
                <div className="heading">
                    <h3>
                        {i18n['creatingObjectPage.theCalendar']}
                    </h3>
                </div>

                <div className="lead_text">
                    <p>
                        {i18n['creatingObjectPage.theCalendar.hint1']}
                    </p>
                </div>

                <div className="clearfix grid">
                    <div className="width-7-10">


                        {/* Нужно, чтобы календарь сам по себе перезагружался без костылей. такая конструкция это обеспечивает */}
                        {isActive && <Calendar
                            currentDays={currentDays}
                            onMonthChange={::this.handleMonthChange}
                            onDayClick={::this.handleDayClick}
                            isLoading={isShowCalendarLoading}
                            onSelectedChange={::this.handleSelectedChange}
                            currencyMark={currentDaysCurrencyMark}
                        />}

                        <ExternalCalendars
                            showImportModal={() => {
                                this.setState({showImportCalendarModal: true})
                            }}
                            onDeleteExternalCalendar={::this.onDeleteExternalCalendar}
                            showExportModal={() => {
                                this.setState({showExportCalendarModal: true})
                            }}/>
                    </div>

                    <div className="width-3-10">
                        <div className="reservation_form">
                            <h4>
                                {i18n['creatingObjectPage.selectDates']}:
                            </h4>

                            <div className="clearfix fields">
                                <div className="tablebox middle one_row clnd-one">
                                    <div className="clnd-one__title">
                                        {i18n['creatingObjectPage.from']}
                                    </div>
                                    <div className="inpt-calendar">
                                        {code !== undefined && <DatePicker
                                            locale={code}
                                            disabled={this.state.selected.length != 0}
                                            className="date_field"
                                            selected={startDate}
                                            openToDate={startDate !== undefined ? startDate : currentMonthToOpen}
                                            dateFormat={AppConst.DATE_FORMAT}
                                            calendarClassName="creating_object_dates_datepicker"
                                            onChange={date => this.handleDateChange(date, 'startDate')}
                                            dayClassName={date => date.isBefore(moment().subtract(1, 'days')) ?
                                                'react-datepicker__day--disabled' :
                                                date.isSame(this.state.startDate) ?
                                                    'selecting-range-start' :
                                                    undefined}
                                        />}
                                    </div>
                                    <div>
                                        <a href="" className="clear" disabled={this.state.selected.length != 0}>
                                            <img
                                                alt=""
                                                src={iconClosePNG}
                                                name={"startDate"}
                                                onClick={::this.handleDateClear}
                                            />
                                        </a>
                                    </div>
                                </div>

                                <div className="tablebox middle one_row mt20 clnd-one">
                                    <div className="clnd-one__title">
                                        {i18n['creatingObjectPage.by']}
                                    </div>
                                    <div className="inpt-calendar">
                                        {code !== undefined && <DatePicker
                                            disabled={this.state.selected.length != 0}
                                            locale={code}
                                            className="date_field"
                                            selected={endDate}
                                            openToDate={endDate !== undefined ? endDate : (startDate !== undefined ? startDate : currentMonthToOpen)}
                                            dateFormat={AppConst.DATE_FORMAT}
                                            calendarClassName="creating_object_dates_datepicker"
                                            onChange={date => this.handleDateChange(date, 'endDate')}
                                            dayClassName={
                                                date => date.isBefore(moment().subtract(1, 'days')) ||
                                                date.isBefore(this.state.startDate) ?
                                                    'react-datepicker__day--disabled' :
                                                    date.isSame(this.state.endDate) ?
                                                        'selecting-range-start' :
                                                        undefined
                                            }
                                        />}
                                    </div>
                                    <div>
                                        <a href="" className="clear" disabled={this.state.selected.length != 0}>
                                            <img
                                                alt=""
                                                src={iconClosePNG}
                                                name={"endDate"}
                                                onClick={::this.handleDateClear}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="clearfix options">
                                <label className="checkbox">
                                    <input
                                        type="checkbox"
                                        checked={isBlocked !== undefined && !isBlocked}
                                        onChange={() => this.handleBlockedChange(false)}
                                    />
                                    <span>{i18n['creatingObjectPage.free']}</span>
                                </label>

                                <label className="checkbox">
                                    <input
                                        type="checkbox"
                                        checked={isBlocked !== undefined && isBlocked}
                                        onChange={() => this.handleBlockedChange(true)}
                                    />
                                    <span>{i18n['creatingObjectPage.busy']}</span>
                                </label>
                            </div>

                            <div className="clearfix costs">
                                <label className="costs__label">
                                    <div className="label__title">
                                        {i18n['creatingObjectPage.pricePerNight']}, {currentDaysCurrencyMark}:
                                    </div>
                                    <input
                                        placeholder="0"
                                        value={this.state.price}
                                        className="label__input"
                                        disabled={isPriceDisabled}
                                        name='price'
                                        onChange={::this.handleInputChange}
                                    />
                                    <label
                                        className={classnames('label__checkbox', {
                                            'active': !isPriceDisabled
                                        })}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={!isPriceDisabled}
                                            className="checkbox__input"
                                            onChange={this.handlePriceDisabledChange}
                                        />
                                    </label>
                                </label>

                                <label className="costs__label">
                                    <div className="label__title">
                                        {i18n['creatingObjectPage.minimumNumberOfNights']}
                                    </div>
                                    <input
                                        placeholder="0"
                                        className="label__input"
                                        value={this.state.minNights}
                                        disabled={isMinNightsDisabled}
                                        onChange={::this.handleInputChange}
                                        name='minNights'
                                    />
                                    <label
                                        className={classnames('label__checkbox', {
                                            'active': !isMinNightsDisabled
                                        })}
                                    >
                                        <input
                                            type="checkbox"
                                            className="checkbox__input"
                                            checked={!isMinNightsDisabled}
                                            onChange={this.handleMinNightsDisabledChange}
                                        />
                                    </label>
                                </label>
                            </div>

                            <div className="clearfix set_params text_center">
                                <a href="" className="button small fullwidth" onClick={::this.handleSetParametersClick}>
                                    <span>
                                        {i18n['creatingObjectPage.setOptions']}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <ExportCalendarModal
                    isOpen={this.state.showExportCalendarModal}
                    onClose={() => {
                        this.setState({showExportCalendarModal: false})
                    }}
                />
                <ImportCalendarModal
                    isOpen={this.state.showImportCalendarModal}
                    onClose={() => {
                        this.setState({showImportCalendarModal: false})
                    }}
                />
            </div>
        )
    }
}

CalendarTab.propTypes = propTypes;
CalendarTab.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    code: state.languages.currentLanguage.code,
    currentDays: state.creatingObjectPage.currentDays,
    currentDaysCurrency: state.creatingObjectPage.currentDaysCurrency,
    objectId: state.creatingObjectPage.createdObject.id,
    isShowCalendarLoading: state.creatingObjectPage.isShowCalendarLoading
});

const mapDispatchToProps = {
    updateDays,
    loadCalendar
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarTab);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/CalendarTab.js